import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { IconSparkles, IconUser } from "./Icons";
import TypingIndicator from "./TypingIndicator";

const Avatar = ({ kind }) => {
	if (kind === "user") {
		return (
			<span className="bodhi-float__avatar bodhi-float__avatar--sm bodhi-float__avatar--user">
				<IconUser />
			</span>
		);
	}
	return (
		<span className="bodhi-float__avatar bodhi-float__avatar--sm">
			<IconSparkles />
		</span>
	);
};

const Message = ({ message }) => {
	const isUser = message.role === "user";
	const isTyping = message.isTyping;
	const hasContent = Boolean(message.content?.trim());

	// While Bodhi is working (streaming a reply or running tools) we only show
	// the spinning avatar bubble — no "Bodhi is working" status and no tool
	// pills. This also keeps the bubble height stable so the reply doesn't jump
	// when the streamed message is swapped for the persisted one.
	const isAssistantWorking = !isUser && message.isStreaming && !hasContent;

	return (
		<div
			className={`bodhi-float__msg ${
				isUser ? "bodhi-float__msg--user" : "bodhi-float__msg--assistant"
			}`}
		>
			{!isUser && <Avatar kind="assistant" />}

			{isTyping || isAssistantWorking ? (
				<TypingIndicator />
			) : (
				<div
					className={`bodhi-float__bubble ${
						isUser
							? "bodhi-float__bubble--user"
							: "bodhi-float__bubble--assistant"
					}`}
				>
					<ReactMarkdown remarkPlugins={[remarkGfm]}>
						{message.content || ""}
					</ReactMarkdown>
				</div>
			)}

			{isUser && <Avatar kind="user" />}
		</div>
	);
};

export default Message;
